import {
  useEffect,
  useState,
  useCallback,
  createContext,
  FC,
  PropsWithChildren,
} from "react";
import { PermissionsAndroid, Platform } from "react-native";
// import {
//   Notifications,
//   Notification,
//   NotificationCompletion,
// } from 'react-native-notifications'; // FIXME
// import messaging from '@react-native-firebase/messaging'; // FIXME
import {
  mutationRegisterPushToken,
  mutationRegisterPushVoipToken,
} from "src/graphql";
// import RNCallKeep from 'react-native-callkeep'; // FIXME
import { EventRegister } from "react-native-event-listeners";
import {
  callKeepStopCallEmit,
  callKeepAnswerCallEmit,
  callKeepCancelCallEmit,
  chatMessageEmit,
  notificationEmit,
  pushNotificationActionEmit,
  PushNotificationEvent,
  PushNotificationActionEvent,
} from "src/utils/event";
// import PushNotification from 'react-native-push-notification'; // FIXME
// import VoipPushNotification from 'react-native-voip-push-notification'; // FIXME
import { useDeeplink } from "./deeplink";
import { useRecoilValue } from "recoil";
import { subscibedChatIdState } from "./chat";
import { Auth } from "aws-amplify";
import { requestUnreadCountState } from "./call";
import { notificationsUnreadCountState } from "./notifications";
import { preOfferChatUnreadCountState } from "./preoffer-chat";
// import PushNotificationIOS from '@react-native-community/push-notification-ios'; // FIXME
import { firebaseConfig, VapidKey } from "src/aws-config";
import { initializeApp } from "firebase/app";
// import { getMessaging, getToken } from "firebase/messaging";
import { Store } from "react-notifications-component";
import { navigationRef } from "src/hooks/navigation";
import { useAuth, AuthState } from "src/hooks/cognito";

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
// const messaging = getMessaging(firebaseApp);

// TODO: move parts to index.js, to prevert slow push
export const usePushNotifications = () => {
  const auth = useAuth();
  const [deviceToken, setDeviceToken] = useState<string | undefined>();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | undefined>();
  const { route } = useDeeplink();
  const subscibedChatId = useRecoilValue<string | undefined>(
    subscibedChatIdState
  );
  let _isMount = true;

  const onMessageHandler = useCallback(
    async (remoteMessage: any) => {
      console.log("onMessageHandler...", remoteMessage);
      if (["preOffer", "callChat"].indexOf(remoteMessage.data.type) !== -1) {
        if (navigator.vibrate) {
          navigator.vibrate([100, 100, 100]);
        }
        chatMessageEmit(
          remoteMessage.data.conversationId,
          remoteMessage.data.type
        );
      } else if (["notification"].indexOf(remoteMessage.data.type) !== -1) {
        notificationEmit(remoteMessage.data.notificationId);
      } else if (["call"].indexOf(remoteMessage.data.type) !== -1) {
        if (navigator.vibrate) {
          navigator.vibrate([
            100, 10, 100, 10, 100, 10, 100, 10, 100, 10, 100, 10, 100,
          ]);
        }
        Store.addNotification({
          title: `${remoteMessage.data.celler}さんから通話依頼があります`,
          type: "danger",
          insert: "top",
          container: "top-center",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 1000 * 60 * 3,
            onScreen: true,
            showIcon: true,
          },
          onRemoval: (id, removedBy) => {
            if (removedBy === "click") {
              navigationRef.current?.navigate("Call");
            }
          },
        });
      }
      if (remoteMessage.notification && remoteMessage.notification.title) {
        if (
          ["preOffer", "callChat"].indexOf(remoteMessage.data.type) !== -1 &&
          remoteMessage.data.conversationId === subscibedChatId
        ) {
          return;
        }
        const title =
          remoteMessage.data.type === "callChat"
            ? undefined
            : remoteMessage.notification.title;
        const message =
          remoteMessage.data.type === "callChat"
            ? undefined
            : remoteMessage.notification.body ||
              remoteMessage.notification.title;

        if (title) {
          Store.addNotification({
            title,
            message,
            type: "info",
            insert: "top",
            container: "top-center",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
              duration: 1000 * 60 * 3,
              onScreen: true,
              showIcon: true,
            },
            onRemoval: (id, removedBy) => {
              if (removedBy === "click") {
                pushNotificationActionEmit(remoteMessage.data);
              }
            },
          });
        }
      }
    },
    [subscibedChatId]
  );

  const refresh = useCallback(async () => {
    if (!_isMount) {
      return;
    }
    if (_isMount) {
      setError(undefined);
    }
    if (_isMount) {
      setLoading(true);
    }
    // Notification.requestPermission().then((permission) => {
    //   if (permission === "granted") {
    //     getToken(messaging, { vapidKey: VapidKey })
    //       .then((token) => console.log("token", token))
    //       .catch((e) => console.error("jonny error", e));
    //   } else {
    //     console.error("push permissions not found");
    //   }
    // });
    // try {

    //     .catch((e) => console.error(e));
    //   // const token = await getToken(messaging, { vapidKey: VapidKey });
    //   // console.log("jonny", token);
    //   // const authStatus = await messaging().requestPermission();
    //   // if (
    //   //   authStatus === messaging.AuthorizationStatus.AUTHORIZED ||
    //   //   authStatus === messaging.AuthorizationStatus.PROVISIONAL
    //   // ) {
    //   //   const token = await messaging().getToken();
    //   //   if (_isMount) {
    //   //     setDeviceToken(token);
    //   //   }
    //   //   await mutationRegisterPushToken({token});

    //   //   Notifications.registerRemoteNotifications();
    //   // }
    // } catch (e) {
    //   if (_isMount) {
    //     setError(e as Error);
    //   }
    // } // FIXME
    // if (_isMount) {
    //   setLoading(false);
    // }
  }, []);

  useEffect(() => {
    if (auth === AuthState.Auth) {
      refresh();
    }
  }, [refresh, auth]);

  useEffect(() => {
    const pushNotificationActionListener = EventRegister.addEventListener(
      PushNotificationActionEvent,
      (e) => route(e.payload)
    );

    return () => {
      EventRegister.removeEventListener(
        pushNotificationActionListener as string
      );
    };
  }, [route]);

  useEffect(() => {
    const pushNotificationListener = EventRegister.addEventListener(
      PushNotificationEvent,
      (e) => onMessageHandler(e.message)
    );

    return () => {
      EventRegister.removeEventListener(pushNotificationListener as string);
    };
  }, [onMessageHandler]);

  useEffect(() => {
    _isMount = true;
    return () => {
      _isMount = false;
    };
  }, []);

  return [deviceToken, loading, error, refresh] as const;
};

export const useAppBadge = () => {
  const requestUnreadCount = useRecoilValue<number>(requestUnreadCountState);
  const notificationsUnreadCount = useRecoilValue<number>(
    notificationsUnreadCountState
  );
  const preOfferChatUnreadCount = useRecoilValue<number>(
    preOfferChatUnreadCountState
  );

  return (
    requestUnreadCount + notificationsUnreadCount + preOfferChatUnreadCount
  );
};

type PushType = undefined;

const PushContext = createContext<PushType>(undefined);

export const PushProvider: FC<PropsWithChildren<{}>> = ({ children }) => {
  usePushNotifications();
  return (
    <PushContext.Provider value={undefined}>{children}</PushContext.Provider>
  );
};
